import { useEffect, useState } from 'react';
import { RoleRouter } from '@/app/routing/RoleRouter';
import { useAppBootstrap } from '@/app/bootstrap/useAppBootstrap';
import { getStartupRecoveryCopy } from '@/app/bootstrap/startupRecovery';
import { initTelegramMiniApp } from '@/roles/client/utils/telegramUtils';
import { useFirstScreenReady } from '@/shared/bootstrap/useFirstScreenReady';
import { updateStartupLoader } from '@/shared/bootstrap/startupLoader';

const FIRST_SCREEN_TIMEOUT_MS = 8_000;

export function App(): JSX.Element {
  const state = useAppBootstrap();
  const isFirstScreenReady = useFirstScreenReady(state.status === 'ready');
  const [firstScreenTimedOut, setFirstScreenTimedOut] = useState(false);

  useEffect(() => {
    if (state.status !== 'ready' || isFirstScreenReady) return undefined;
    const timer = window.setTimeout(() => setFirstScreenTimedOut(true), FIRST_SCREEN_TIMEOUT_MS);
    return () => window.clearTimeout(timer);
  }, [isFirstScreenReady, state.status]);

  useEffect(() => {
    initTelegramMiniApp();
  }, []);

  useEffect(() => {
    if (state.status !== 'error' && !isFirstScreenReady && !firstScreenTimedOut) return;

    if (isFirstScreenReady) updateStartupLoader(5);

    const timer = window.setTimeout(() => {
      const initialLoader = document.getElementById('initial-loader');
      if (!initialLoader) return;

      initialLoader.classList.add('startup-loader--hide');

      window.setTimeout(() => {
        initialLoader.remove();
      }, 180);
    }, 1000);

    return () => {
      window.clearTimeout(timer);
    };
  }, [firstScreenTimedOut, isFirstScreenReady, state.status]);

  if (state.status === 'ready') {
    return <RoleRouter role={state.role} workflowSettings={state.workflowSettings} />;
  }
  if (state.status === 'error') {
    const recovery = getStartupRecoveryCopy(state.message);
    return (
      <main className="startup-recovery" role="alert">
        <div className="startup-recovery__card">
          <h1>{recovery.title}</h1>
          <p>{recovery.description}</p>
          <button type="button" onClick={() => window.location.reload()}>{recovery.action}</button>
        </div>
      </main>
    );
  }
  return <></>;
}
